<template>
	<div
		class="form"
		:class="{
			[className]: className,
			'is-loading': loading
		}"
	>
		<Spinner />
		
		<form action="?" method="post" @submit="$emit('submit', $event)">
			<slot />
		</form>
	</div>
	<!-- /.form -->
</template>

<script>
/**
 * Internal Dependencies
 */
import FormGroup from './form-group';
import FormStatus from './form-status';
import FormActions from './form-actions';
import FormMessage from './form-message';
import FormHead from './form-head';
import FormBody from './form-body';
import FormDivider from './form-divider';
import FormEntry from './form-entry';
import Spinner from '@/components/spinner/spinner';

export default {
	/**
	 * Form
	 */
	name: 'Form',

	/**
	 * Events
	 *
	 * Vue 3 drops every listener not declared here onto the root element as a
	 * native one. `submit` bubbles from the inner <form> up to that root <div>,
	 * so an undeclared `submit` ran the parent's handler twice - once through
	 * this emit, once through the fallthrough listener - and every form in the
	 * app submitted twice.
	 */
	emits: ['submit'],

	/**
	 * Components
	 */
	components: {
		Spinner,
	},

	/**
	 * Props
	 */
	props: {
		className: {
			type: String,
			default: ''
		},
		loading: {
			type: Boolean,
			default: false
		}
	}
};

export {
	FormActions,
	FormMessage,
	FormHead,
	FormBody,
	FormStatus,
	FormGroup,
	FormDivider,
	FormEntry
};
</script>
